"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.changeRange = void 0;
const uuid_1 = require("@lukeed/uuid");
const ml_spectra_processing_1 = require("ml-spectra-processing");
const nmr_processing_1 = require("nmr-processing");
const detectSignal_1 = __importDefault(require("./detectSignal"));
function changeRange(spectrum, range) {
    const { from, to, id } = range;
    const { x, re } = spectrum.data;
    const index = spectrum.ranges.values.findIndex((i) => i.id === id);
    const absolute = (0, ml_spectra_processing_1.xyIntegration)({ x, y: re }, { from, to, reverse: true });
    const signal = (0, detectSignal_1.default)({ x, re }, {
        from,
        to,
        frequency: spectrum.info.originFrequency,
        checkMaxLength: false,
    });
    if (index !== -1) {
        spectrum.ranges.values[index] = {
            ...spectrum.ranges.values[index],
            originalFrom: from,
            originalTo: to,
            ...range,
            absolute,
            signals: [
                {
                    id: (0, uuid_1.v4)(),
                    ...(signal || {
                        multiplicity: 's',
                        kind: 'signal',
                        delta: 0,
                        js: [],
                        diaIDs: [],
                    }),
                },
            ],
        };
        (0, nmr_processing_1.updateRangesRelativeValues)(spectrum);
    }
}
exports.changeRange = changeRange;
